export const config = {
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN ?? "",
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID ?? "",
  AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL ?? "",
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE ?? "",
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL ?? "",
  MAS_URL: process.env.REACT_APP_MAS_URL ?? "",
};
